import React from 'react'
import FilterCard from '../../components/filter-card'
import { UserTypeEnum, CommonAllOption } from '../../utils/enums'

const AgentsFilter = ({ filters, onFilterChange, onFilterSubmit, onClearFilters, onRefresh, loading }) => {
  // Boolean filter options
  const booleanOptions = [
    CommonAllOption,
    { value: 'true', label: 'AGENTS_FILTERS_YES' },
    { value: 'false', label: 'AGENTS_FILTERS_NO' }
  ]

  const fields = [
    {
      type: 'input',
      name: 'search',
      placeholder: 'AGENTS_FILTERS_SEARCH_PLACEHOLDER',
      icon: 'zmdi zmdi-search'
    },
    {
      type: 'input',
      name: 'city',
      placeholder: 'AGENTS_FILTERS_CITY_PLACEHOLDER',
      icon: 'zmdi zmdi-city'
    },
    {
      type: 'input',
      name: 'country',
      placeholder: 'AGENTS_FILTERS_COUNTRY_PLACEHOLDER',
      icon: 'zmdi zmdi-globe-alt'
    },
    {
      type: 'select',
      name: 'has_active_contract',
      placeholder: 'AGENTS_FILTERS_HAS_ACTIVE_CONTRACT_PLACEHOLDER',
      roleBased: true,
      roleAccess: UserTypeEnum.ADMIN,
      options: booleanOptions
    },
    {
      type: 'select',
      name: 'contract_expiring_soon',
      placeholder: 'AGENTS_FILTERS_CONTRACT_EXPIRING_SOON_PLACEHOLDER',
      roleBased: true,
      roleAccess: UserTypeEnum.ADMIN,
      options: booleanOptions
    }
  ]

  const defaultFilters = {
    search: '',
    city: '',
    country: '',
    has_active_contract: '',
    contract_expiring_soon: ''
  }

  return (
    <FilterCard
      filters={filters}
      onFilterChange={onFilterChange}
      onFilterSubmit={onFilterSubmit}
      onClearFilters={onClearFilters}
      onRefresh={onRefresh}
      loading={loading}
      title="AGENTS_FILTERS_TITLE"
      titleHide="AGENTS_FILTERS_HIDE"
      titleShow="AGENTS_FILTERS_SHOW"
      fields={fields}
      defaultFilters={defaultFilters}
      autoSubmitFields={['has_active_contract', 'contract_expiring_soon']}
    />
  )
}

export default AgentsFilter

